module.exports = __webpack_public_path__ + "img/cover.821cfbe3.jpg";